import { FormikProps } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomField } from '../../../../../../global/components/form-element/custom-field';
import { FormField } from '../../../../../../global/components/form-element/form-field';
import { RadioTable } from '../../../../../../global/components/form-element/radio-table';
import { FormGroup } from '../../../../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../../../../global/components/layout/generic-content-spacer';
import { DividerSection } from '../../../../../../global/components/layout/divider-section';
import { billingAccountOptions, BillingAccountOptionValues, taxOptions } from '../../../new-participant-enrollment/models/form-options';
import { CoveragePerson, CoveragePlans, DisplayLabels, PlanSelectionComponentModel } from '../models/coverage-models';
import { getOptionDisplays, isMedicalDental } from '../helpers/coverage-display-helpers';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { getBillingAccountDisabledState, onCoverageChange } from '../helpers/coverage-form-helpers';
import { CalculatedTiers } from '../../models/new-hire-enrollment-models';
import { getLetterMonthDate } from '../../../../../../global/helpers/date-helpers';
import { WysiwygWithReactLink } from '../../../../../../global/components/wysiwyg-with-react-link';
import { replaceAll } from '../../../../../../global/helpers/string-helpers';

interface Props {
	memberEnroll: boolean;
	formikProps: FormikProps<any>;
	componentModel: PlanSelectionComponentModel;
	eligibleDependents?: CoveragePerson[];
	plans?: CoveragePlans;
	radioTableLabels?: JSX.Element;
	noPlanOfferMessage?: string;
	displayLabels?: DisplayLabels;
	setRemoveSelfFlag?: any;
	tierKey?: string;
	showTax?: boolean;
	customFieldsForRadioOption?: JSX.Element;
	showPlanCodeInName?: boolean;
	memberSelection?: boolean;
	isDioApprover?: boolean,
	displayPlanSelectionDioApprover?: boolean,
}
export function PlanSelectionItem(props: Props) {

	const { memberEnroll, formikProps, noPlanOfferMessage, componentModel, plans, radioTableLabels, setRemoveSelfFlag, tierKey, showTax, displayLabels, customFieldsForRadioOption, showPlanCodeInName, memberSelection, eligibleDependents, isDioApprover, displayPlanSelectionDioApprover } = props;
	const displayTier = useSelector<TcsmStates, CalculatedTiers>(state => state?.newHireEnrollmentState[tierKey]);

	const dispatch = useDispatch();

	if (plans?.plans?.length === 0) {
		return (
			<div className='grid-main-content'>
				<DividerSection sectionText={componentModel?.planTypeName} removeDivider >
					<WysiwygWithReactLink content={noPlanOfferMessage} />
				</DividerSection>
			</div>
		);
	}

	if (memberEnroll || !displayPlanSelectionDioApprover) {
		return (
			<div className='grid-main-content'>
				<DividerSection sectionText={componentModel?.planTypeName} removeDivider >
					<ContentSpacer>
						<FormGroup>
							<div className='form-indent'>
								<div className='form-item'>
									<FormField
										name={`${componentModel?.formPlanTypeName}_billingAccountType`}
										label='Billing Accounts'
										component='radioGroup'
										options={billingAccountOptions}
										touched={formikProps.touched}
										errors={formikProps.errors}
										disabled={getBillingAccountDisabledState(plans?.billing_preference)}
									/>
									<p>{formikProps?.values[`${componentModel?.formPlanTypeName}_billingAccountType`] === BillingAccountOptionValues.INSTITUTION ? plans?.account_number : plans?.diocese_account_number}</p>
								</div>
								<div className='form-item'>
									<p><strong>{componentModel?.settings?.effectiveDateLabel}</strong></p>
									<p>{getLetterMonthDate(replaceAll(plans?.effective_date, '-', '/'))}</p>
								</div>
							</div>
						</FormGroup>
					</ContentSpacer>
				</DividerSection>
			</div>
		);
	}


	return (
		<>
			<div className='grid-main-content' id={ isDioApprover ? 'groupLifeReference' : '' }>
				<DividerSection sectionText={componentModel?.planTypeName} removeDivider >
					<ContentSpacer>
						<FormGroup>
							{
								!memberSelection &&
								<div className='form-item'>
									<FormField
										name={`${componentModel?.formPlanTypeName}_billingAccountType`}
										label={componentModel?.settings?.billingAccountLabel}
										component='radioGroup'
										options={billingAccountOptions}
										touched={formikProps.touched}
										errors={formikProps.errors}
										disabled={getBillingAccountDisabledState(plans?.billing_preference)}
									/>
									<p>{formikProps?.values[`${componentModel?.formPlanTypeName}_billingAccountType`] === BillingAccountOptionValues.INSTITUTION ? plans?.account_number : plans?.diocese_account_number}</p>
								</div>
							}
							<div className='form-item'>
								<p><strong>{componentModel?.settings?.effectiveDateLabel}</strong></p>
								<p>{getLetterMonthDate(replaceAll(plans?.effective_date, '-', '/'))} </p>
							</div>
							{
								showTax &&
								<div className='form-item'>
									<FormField
										name={`${componentModel?.formPlanTypeName}_tax`}
										label={componentModel?.settings?.taxOptionLabel}
										component='radioGroup'
										options={taxOptions}
										touched={formikProps.touched}
										errors={formikProps.errors}
									/>
									<p>{plans?.account_number}</p>
								</div>
							}
						</FormGroup>
					</ContentSpacer>
				</DividerSection>
			</div>
			<div className='grid-fw-content'>
				<DividerSection>
					<CustomField
						name={componentModel?.formPlanTypeName}
						label={
							<div className={`coverage-table-row header-row ${isMedicalDental(componentModel?.formPlanTypeName) && 'header-row-bottom-align'}`}>
								<div className='coverage-table-row-cell'><h4>{componentModel?.planNamesLabel}</h4></div>
								{radioTableLabels}
							</div>
						}
						component={RadioTable}
						options={getOptionDisplays(
							plans?.plans,
							formikProps?.values[componentModel?.formPlanTypeName],
							displayTier?.display_tier,
							componentModel?.settings,
							componentModel.labelSettings,
							componentModel.declineOptionText,
							false,
							displayLabels,
							formikProps,
							plans?.group_id,
							customFieldsForRadioOption,
							showPlanCodeInName,
						)}
						formProps={formikProps}
						onChange={
							(e) =>
								onCoverageChange(e,
									componentModel?.formPlanTypeName,
									formikProps,
									plans,
									dispatch,
									eligibleDependents,
									setRemoveSelfFlag,
								)
						}
					/>
				</DividerSection>
			</div>
		</>
	);
}

PlanSelectionItem.defaultProps = {
	setRemoveSelfFlag: null,
	tierKey: null,
	showTax: false,
	plans: null,
	radioTableLabels: null,
	displayLabels: null,
	customFieldsForRadioOption: null,
	showPlanCodeInName: false,
	memberSelection: false,
	noPlanOfferMessage: null,
	eligibleDependents: null,
	isDioApprover: false,
	displayPlanSelectionDioApprover: false,
};